/* tslint:disable */
/* eslint-disable */
/**
 * HAU.ITDE.Guarantee.Free.Portal.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GuaranteeAdd } from '../model';
// @ts-ignore
import type { GuaranteeCheck } from '../model';
// @ts-ignore
import type { GuaranteeResponse } from '../model';
// @ts-ignore
import type { Page } from '../model';
// @ts-ignore
import type { ProblemDetails } from '../model';
/**
 * GuaranteeApi - axios parameter creator
 * @export
 */
export const GuaranteeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Website Page
         * @param {string} [locale] 
         * @param {string} [baseUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GuaranteeConfigurationGet: async (locale?: string, baseUrl?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/guarantee/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (baseUrl !== undefined) {
                localVarQueryParameter['baseUrl'] = baseUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new Guarantee
         * @param {GuaranteeAdd} [guaranteeAdd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GuaranteePost: async (guaranteeAdd?: GuaranteeAdd, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/guarantee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guaranteeAdd, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if Guarantee is available for serialnumber, locale and IsPublic
         * @param {GuaranteeCheck} [guaranteeCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GuaranteeValidPost: async (guaranteeCheck?: GuaranteeCheck, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/guarantee/valid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guaranteeCheck, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GuaranteeApi - functional programming interface
 * @export
 */
export const GuaranteeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GuaranteeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Website Page
         * @param {string} [locale] 
         * @param {string} [baseUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1GuaranteeConfigurationGet(locale?: string, baseUrl?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Page>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1GuaranteeConfigurationGet(locale, baseUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GuaranteeApi.v1GuaranteeConfigurationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a new Guarantee
         * @param {GuaranteeAdd} [guaranteeAdd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1GuaranteePost(guaranteeAdd?: GuaranteeAdd, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuaranteeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1GuaranteePost(guaranteeAdd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GuaranteeApi.v1GuaranteePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if Guarantee is available for serialnumber, locale and IsPublic
         * @param {GuaranteeCheck} [guaranteeCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1GuaranteeValidPost(guaranteeCheck?: GuaranteeCheck, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1GuaranteeValidPost(guaranteeCheck, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GuaranteeApi.v1GuaranteeValidPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GuaranteeApi - factory interface
 * @export
 */
export const GuaranteeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GuaranteeApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Website Page
         * @param {string} [locale] 
         * @param {string} [baseUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GuaranteeConfigurationGet(locale?: string, baseUrl?: string, options?: RawAxiosRequestConfig): AxiosPromise<Page> {
            return localVarFp.v1GuaranteeConfigurationGet(locale, baseUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new Guarantee
         * @param {GuaranteeAdd} [guaranteeAdd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GuaranteePost(guaranteeAdd?: GuaranteeAdd, options?: RawAxiosRequestConfig): AxiosPromise<GuaranteeResponse> {
            return localVarFp.v1GuaranteePost(guaranteeAdd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if Guarantee is available for serialnumber, locale and IsPublic
         * @param {GuaranteeCheck} [guaranteeCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GuaranteeValidPost(guaranteeCheck?: GuaranteeCheck, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1GuaranteeValidPost(guaranteeCheck, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GuaranteeApi - interface
 * @export
 * @interface GuaranteeApi
 */
export interface GuaranteeApiInterface {
    /**
     * 
     * @summary Get Website Page
     * @param {string} [locale] 
     * @param {string} [baseUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuaranteeApiInterface
     */
    v1GuaranteeConfigurationGet(locale?: string, baseUrl?: string, options?: RawAxiosRequestConfig): AxiosPromise<Page>;

    /**
     * 
     * @summary Add a new Guarantee
     * @param {GuaranteeAdd} [guaranteeAdd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuaranteeApiInterface
     */
    v1GuaranteePost(guaranteeAdd?: GuaranteeAdd, options?: RawAxiosRequestConfig): AxiosPromise<GuaranteeResponse>;

    /**
     * 
     * @summary Check if Guarantee is available for serialnumber, locale and IsPublic
     * @param {GuaranteeCheck} [guaranteeCheck] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuaranteeApiInterface
     */
    v1GuaranteeValidPost(guaranteeCheck?: GuaranteeCheck, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * GuaranteeApi - object-oriented interface
 * @export
 * @class GuaranteeApi
 * @extends {BaseAPI}
 */
export class GuaranteeApi extends BaseAPI implements GuaranteeApiInterface {
    /**
     * 
     * @summary Get Website Page
     * @param {string} [locale] 
     * @param {string} [baseUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuaranteeApi
     */
    public v1GuaranteeConfigurationGet(locale?: string, baseUrl?: string, options?: RawAxiosRequestConfig) {
        return GuaranteeApiFp(this.configuration).v1GuaranteeConfigurationGet(locale, baseUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new Guarantee
     * @param {GuaranteeAdd} [guaranteeAdd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuaranteeApi
     */
    public v1GuaranteePost(guaranteeAdd?: GuaranteeAdd, options?: RawAxiosRequestConfig) {
        return GuaranteeApiFp(this.configuration).v1GuaranteePost(guaranteeAdd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if Guarantee is available for serialnumber, locale and IsPublic
     * @param {GuaranteeCheck} [guaranteeCheck] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuaranteeApi
     */
    public v1GuaranteeValidPost(guaranteeCheck?: GuaranteeCheck, options?: RawAxiosRequestConfig) {
        return GuaranteeApiFp(this.configuration).v1GuaranteeValidPost(guaranteeCheck, options).then((request) => request(this.axios, this.basePath));
    }
}

